<page-grid [gridConfig]="gridConfig()" (gridClickColumn)="handleItemClick($event)"/>
